import * as S from './styled'

import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { t } from 'i18next'
import api from '@/core/services/api'
import { useAlert } from '@/core/context/useWindow'

export default function MGamePlay() {
  const { vendor, id, currency } = useParams()
  const navigate = useNavigate()
  const { openAlert } = useAlert()
  const [link, setLink] = useState('')

  // 게임은 새 창으로 열린다 — 돌아갈 이전 화면이 없으면 창을 닫고, 닫히지 않는 창(주소 직접 입력 등)은 모바일 메인으로
  const leaveGame = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }
    window.close()
    navigate('/m', { replace: true })
  }

  useEffect(() => {
    if (!id || !vendor || !currency) return
    api.get('/user-game/game-launch-link', {
      params: { game_id: id, vendor, currency }
    })
      .then((res) => {
        const content = res.data?.content
        const gameLink = content?.link || content
        if (gameLink) setLink(gameLink)
      })
      .catch((err) => {
        console.error(err)
        // 점검중 안내(게임사 우선) — 그 외는 기존 메시지
        const code = err.response?.data?.errors?.[0]?.msg?.code
        const msg = code === 'G011' ? t('bet_reject.vendor_maintenance')
          : code === 'G010' ? t('bet_reject.game_maintenance')
            : (err.response?.data?.message || t('error.unknown'))
        // gold 알림 상자로 안내하고, 확인을 누르면 게임 화면을 떠난다
        openAlert({ message: msg, Func: leaveGame })
      })
  }, [id, vendor, currency])

  // 게임 화면에 있는 동안 뒤 문서가 스크롤되지 않게 막는다
  useEffect(() => {
    const html = document.documentElement
    const prev = html.style.overflow
    html.style.overflow = 'hidden'
    return () => { html.style.overflow = prev }
  }, [])

  // Gold 모바일 게임 화면도 PC 처럼 머리줄·버튼 줄(새 창·전체화면·뒤로가기) 없이 게임만 화면 가득(2026-10-23 요청)
  return (
    <S.Wrap>
      {link && (
        <S.GameFrame
          src={link}
          allowFullScreen
          allow="autoplay; fullscreen"
        />
      )}
    </S.Wrap>
  )
}
